import React, { useEffect, useState, useMemo, useCallback, useRef } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Typography, Card, CardContent, CardMedia, IconButton, TextField, MenuItem, Switch, Input, InputAdornment, Button, Skeleton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import '../sales.scss' 
import { POS } from '../../../../constant/pos'; 
import SkeletonProduct from '../../../../components/skeleton/skeletonProduct';
import SkeletonOtherSelect from '../../../../components/skeleton/skeletonOtherSelect';


const Auth = () => {
    const [products, setProducts] = useState(() => {
        const storedProducts = sessionStorage.getItem('Products');
        return storedProducts ? JSON.parse(storedProducts) : [];
    });
    const [inCartProducts, setInCartProducts] = useState([]);
    const api = useSelector((state) => state.Api);
    const [originalProducts, setOriginalProducts] = useState([]); // To keep the original product data
    const [searchQuery, setSearchQuery] = useState(""); // Search query state
    const [searchByKey, setSearchByKey] = useState(""); // Search query state
    const [searchByFormula, setSearchByFormula] = useState(""); // Search query state
    const [searchByBatch, setSearchByBatch] = useState(""); // Search query state
    const [searchByName, setSearchByName] = useState(""); // Search query state//
    const [searchByCate, setSearchByCate] = useState(""); // Search query state//
    const [searchByBrand, setSearchByBrand] = useState(""); // Search query state//
    const [data, setData] = useState(POS().Sale);
    const [openPopup, setOpenPopup] = useState(false);
    const [formData, setFormData] = useState({ name: "", phone: "" });
    const [customerSuggestions, setCustomerSuggestions] = useState([]); // To keep the original product data
    const [discount, setDiscount] = useState(0); // To keep the original product data
    const [printOpen, setPrintOpen] = useState(false); // To keep the original product data
    const [paymentData, setPaymentData] = useState(); // To keep the original product data
    const [customerID, setCustomerID] = useState(1); // To keep the original product data
    const [selectedCustomer, setSelectedCustomer] = useState(null); // Store selected customer
    const [categories, setCategories] = useState(() => {
        const storedCategories = sessionStorage.getItem('Categories');
        return storedCategories ? JSON.parse(storedCategories) : [];
    });

    const [brands, setBrands] = useState(() => {
        const storedBrands = sessionStorage.getItem('Brands');
        return storedBrands ? JSON.parse(storedBrands) : [];
    });
    const [selectedCategory, setSelectedCategory] = useState([]); // Store selected customer
    const [userToken, setUserToken] = useState(JSON.parse(localStorage.getItem('User_Data'))?.token || undefined);
    const dispatch = useDispatch();
    const [uniteTypes, setUniteTypes] = useState([]);
    const [loan, setLoan] = useState(false);
    const [editingStates, setEditingStates] = useState({});
    const [billCss, setBillCss] = useState({bottom:0, position:'fixed', width:'98%', zIndex:'999', background:'white', padding:'0px !important', maxHeight:'36px', boxShadow:'0 1px 7px 0 rgba(0, 0, 0, 0.2), 0 -1px 17px 0 rgba(0, 0, 0, 0.19)', borderRadius:'8px', marginLeft:'1%'})
    const [isBillOpen, setBillOpen] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth >1024? false: true)
    const fetchingRoles = JSON.parse(localStorage.getItem('User_Data'))?.role || undefined;
    let getRoles = fetchingRoles == undefined ? undefined : fetchingRoles  == undefined ? 'empty' : fetchingRoles;
    const initialProd = useRef(false);
    const initialCust = useRef(false);
    const initialCate = useRef(false);
    const initialBrands = useRef(false);
    const initialUnite = useRef(false);
      // Fetch Products - Added useCallback to prevent unnecessary recreations
    const fetchProducts = useCallback(async () => {
        const cachedProducts = sessionStorage.getItem('Products');
        const cachedUnitTypes = sessionStorage.getItem('unitTypes');
        if (cachedProducts && cachedUnitTypes) {
            setProducts(JSON.parse(cachedProducts));
            setOriginalProducts(JSON.parse(cachedProducts));
            setUniteTypes(JSON.parse(cachedUnitTypes));
            return; // Exit early if data exists in sessionStorage
        }
        if (initialProd.current) return;
        initialProd.current = true 
        // dispatch(ShowLoader('1'))
        try {
            //console.log(userToken)
            const response = await axios.get(api.showProducts, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            });

            if (response.status === 200) {
                setProducts(response.data.data);
                setOriginalProducts(response.data.data);
                setUniteTypes(response?.data?.unitTypes);
                sessionStorage.setItem('Products', JSON.stringify(response?.data?.data))
                sessionStorage.setItem('unitTypes', JSON.stringify(response?.data?.unitTypes))
            }
        } catch (err) {
            console.error('Error fetching products:', err);
        }
    }, [api.showProducts, userToken]);

    // Fetch Customers - Added useCallback
     
    // Fetch Categories - Added useCallback
    const fetchCategories = useCallback(async () => {
        const cachedCategories = sessionStorage.getItem('Categories');
        if (cachedCategories) {
            setCategories(JSON.parse(cachedCategories));
            return; // Exit early if data exists in sessionStorage
        }
        if (initialCate.current) return;
        initialCate.current = true 
        // dispatch(ShowLoader('1'))
        try {
            const response = await axios.get(api.showCategories, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                },
            });
            if (response.status === 200) {
                setCategories(response?.data?.data);
                setBrands(response?.data?.brands);
                sessionStorage.setItem('Categories',JSON.stringify(response?.data?.data))
                sessionStorage.setItem('Brands',JSON.stringify(response?.data?.brands))
                // dispatch(ShowLoader('0'))
                // fetchBrands()
            }
        } catch (err) {
            console.error('Error fetching categories:', err);
        }
    }, [api.showCategories, userToken]);

    // Fetch Brands - Added useCallback
     

     
    useEffect(() => {
        // Create an async function to fetch all initial data
        const fetchInitialData = async () => {
            await fetchProducts();
            // await fetchCustomers();
            await fetchCategories();
            // await fetchUniteType();
            // await fetchBrands();
        };

        fetchInitialData();
        
        // Cleanup function if needed
        return () => {
            // Any cleanup code if needed
        };
    }, []); 

    // Handle Product Click
    useEffect(() => {
        if (String(searchQuery)?.trim() === "") {
            setProducts(originalProducts);
        } else {
            const filteredProducts = originalProducts.filter(product => {
                // //console.log(product.batchnumber)
                if (searchByKey == 'Name') {
                    return product?.product_name.toLowerCase().includes(searchQuery.toLowerCase()) || false
                }
                else if (searchByKey == 'Formula') {
                    //console.log('formula', searchQuery)

                    return product?.product_code.toLowerCase().includes(searchQuery.toLowerCase()) || false
                }
                else if (searchByKey === 'Batch') {
                    //console.log('batch', searchQuery);
                    return product?.batchnumber?.toLowerCase().includes(searchQuery.toLowerCase()) || false;
                }
                else if (searchByKey === 'Category') {
                    //console.log('Category', originalProducts);
                    // return product?.category_id?.toLowerCase().includes(searchQuery.toLowerCase()) || false;
                    return product?.category_id === parseInt(searchQuery);
                }
                else if (searchByKey === 'Brands') {
                    return product?.brand_id === parseInt(searchQuery);
                }
                else {
                    return product?.product_name.toLowerCase().includes(searchQuery.toLowerCase())

                }
            }
            );
            setProducts(filteredProducts);
        }
    }, [searchQuery, originalProducts]);


    const searchBy = (key, event) => {
        //console.log(key, event.target.value)
        setSearchByKey(key)
        setSearchQuery(event.target.value)
        if (key == 'Formula')
            setSearchByFormula(event.target.value)
        else if (key == 'Name')
            setSearchByName(event.target.value)
        else if (key == 'Batch')
            setSearchByBatch(event.target.value)
        else if (key == 'Category')
            setSearchByCate(event.target.value)
        else if (key == 'Brands')
            setSearchByBrand(event.target.value)
        else if (key == 'All')
            setSearchByBrand()
    }
     
    return (
        <Grid container spacing={2} sx={{   overflow: "hidden" }}>
            {/* Products Grid */}
            <Grid item xs={ 12} sx={!isMobile? {  position: "fixed", zIndex:9999, left: '20%', top: 0, bottom: 0, overflowY: "auto" } : {}}>
                <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap" }}>
                    <Grid item xs={2}>
                        <Button variant="contained" style={{width:'100%', height:'52px'}} color="primary" onClick={(e)=>searchBy('All',e)}>ټول </Button>
                
                        {/* <CustomBtn data={data.scannerBtn} onClick={(e)=>searchBy('All',e)} style={{ margin: 'auto', display: 'block', Padding: '10px' }} /> */}
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            //label="Search By Name"
                            label="جنس نوم"
                            variant="outlined"
                            value={searchByName}
                            onChange={(e) => searchBy('Name', e)}
                            // onChange={(e) => setSearchQuery(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        {/* {categories.length > 0 ? 
                        <TextField
                            select
                            label="کیټیګری"
                            variant="outlined"
                            fullWidth
                            className='dropdown'
                            sx={{ mb: 2 }}
                            value={searchByCate}  // You'll need to track this in state
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedName = categories.find(cat => cat.category_id === selectedId)?.category_name;
                                // handleCategoryChange(selectedId, selectedName);
                                searchBy('Category', e)
                            }}
                        >
                            {categories?.map((option) => (
                                <MenuItem key={option.category_id} value={option.category_id}>
                                    {option.category_name}
                                </MenuItem>
                            ))}
                        </TextField>
                         :  
                            <SkeletonOtherSelect /> 
                        } */}
                        
                        <TextField
                                fullWidth
                                label="Formula"
                                variant="outlined"
                                value={searchByFormula}
                                onChange={(e) => searchBy('Formula', e)}
                                sx={{ mb: 2 }}
                            />    

                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            label="Batch"
                            variant="outlined"
                            value={searchByBatch}
                            onChange={(e) => searchBy('Batch', e)}
                            // onChange={(e) => setSearchQuery(e.target.value)}
                            sx={{ mb: 2 }}
                        />
                         
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>
                    <Grid item xs={2}>
                    </Grid>
                </Grid>
                 
                <Grid container spacing={2} sx={{ display: "flex", flexWrap: "wrap" }}>
                    {products && products.length > 0
                        ? products.map((product) => (
                            <Grid item xs={6} sm={2} md={2} lg={2} key={product.product_id}>
                            <Card
                                sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                width: "100%",
                                height: "100%",
                                borderRadius: 2,
                                cursor: "pointer",
                                backgroundColor: product.stock_quantity == 0 ? '#d3d3d35c' : '',
                                textAlign: "center",
                                p: 0,
                                "&:hover": { boxShadow: 10 }
                                }}
                                // onClick={() => handleProductClick(product)}
                            >
                                <CardMedia
                                component="img"
                                height="100"
                                image={`${
                                     `${process.env.PUBLIC_URL}/images/logos/default.jpg`
                                    }`}

                                // image={`${process.env.PUBLIC_URL}/images/logos${product?.imagePath === null || product?.imagePath === undefined ? '/default.jpg' : api.web product?.imagePath }`} 
                                alt={product.product_name}
                                />
                                <CardContent>
                                <Typography variant="h6" noWrap>{product.product_name}</Typography>
                                <Typography variant="body2" color="textSecondary">{product.product_code}</Typography>
                                <Typography variant="displayItemPrice" className='displayItemPrice'>{product.selling_price}</Typography>
                                {getRoles === 1? <p variant="displayPruchasePrice" className='displayPruchasePrice'>P_{product?.average_price?.toFixed(2)}</p> : null}
                                <Typography variant="body2">
                                    <span className='type'>{uniteTypes.find((unite) => unite.unite_id === product.uniteType)?.unite_name ||  ' دانه '}</span>
                                    <span className='typeQuantity'>{parseFloat(product?.stock_quantity)?.toFixed(0)}</span>
                                </Typography>
                                <Typography variant="body2" className='descript' sx={{ fontSize: "0.8rem", color: "gray" }}>
                                    {product.description}
                                </Typography>
                                </CardContent>
                            </Card>
                            </Grid>
                        ))
                        : 
                        Array.from(new Array(12)).map((_, index) => (
                            <Grid item xs={6} sm={4} md={4} lg={3}  >
                                <SkeletonProduct />
                            </Grid>
                        ))
                    } 
                </Grid>
            </Grid>

            {/* Welcome Section - Row-wise Display */}
{/*              
            <AddCustomer
                open={openPopup}
                onClose={handlePopupClose}
                formData={formData}
                onFormChange={handleFormChange}
                onSubmit={handleFormSubmit}
                customers={customerSuggestions}
            />
            {localStorage.getItem('WebSrn') == 4 ? 
                  <PrintBillDialogQareeb  open={printOpen} onClose={printBill} paymentData={paymentData} />
            
                   :
                  <PrintBillDialog  open={printOpen} onClose={printBill} paymentData={paymentData} />
                  } */}
         </Grid>
    );
};

export default Auth;
